import { TagIcon } from "@eisinc/MobiusOverrides/Tag";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color } from "@eisinc/XDL/Utilities";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        css: css`
            max-width: unset;
            min-height: unset;
            align-items: center;
            border-radius: 13px;
            background: ${color("primary")};
            transition: all 0.3s ease;
            padding: 5px 4px 4px 8px;
            margin: 0;

            &:hover,
            &:focus {
                &,
                button {
                    transition: all 0.3s ease;
                    background: ${color("common.ui8")};
                }
            }

            button {
                background-color: transparent;
                transition: none;
                min-height: auto;
                line-height: 1;
                margin-right: 2px;
                margin-left: 8px;
                height: 14px;

                &:hover,
                &:focus {
                    background-color: transparent;
                }
                flex-basis: unset;
            }

            ${TagIcon} {
                color: ${color("common.white")};
                top: 0;

                &,
                > svg {
                    width: 12px;
                    height: 12px;
                }
            }
        `,
        typographyProps: {
            ...fontConfig.singleLineSmall,
            weight: fontConfig.weight.medium,
            color: "common.white",
            css: css`
                margin: 0;

                > span {
                    font-weight: ${fontConfig.weight.regular};
                }
            `,
        },
    },
} as xBaseTheme["tag"];
